// extracted by mini-css-extract-plugin
module.exports = {"root":"quoted-tweet-container_root__Cov6B","article":"quoted-tweet-container_article__VNKV_"};